import { InvisibleCaptcha } from 'features/index';

import { AppRouter } from './routers/appRouter';
import { Providers } from './providers';

export const App = () => (
  <Providers>
    <InvisibleCaptcha />
    <AppRouter />
  </Providers>
);
